// Preferenza lingua persistente, condivisa tra sito marketing (URL prefissati,
// next-intl) e area app (/app, AppLocaleContext).
// - localStorage 'lb-locale': letta da AppLocaleProvider dentro /app.
// - cookie 'NEXT_LOCALE': letto dal proxy per reindirizzare le richieste senza
//   prefisso locale verso il prefisso preferito (es. / -> /fr).
// Solo client-side.

export const LOCALES = ['it', 'en', 'es', 'de', 'fr', 'tr'] as const;
export type Locale = (typeof LOCALES)[number];
export const DEFAULT_LOCALE: Locale = 'en';

export const LOCALE_STORAGE_KEY = 'lb-locale';
export const LOCALE_COOKIE = 'NEXT_LOCALE';

const ONE_YEAR_SECONDS = 60 * 60 * 24 * 365;

export function isLocale(value: string | null | undefined): value is Locale {
  return (LOCALES as readonly string[]).includes(value ?? '');
}

/** Salva la lingua scelta in localStorage + cookie (sopravvive al giro di auth). */
export function persistLocalePreference(code: Locale) {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(LOCALE_STORAGE_KEY, code);
  } catch {
    /* storage non disponibile: il cookie basta per il routing */
  }
  document.cookie = `${LOCALE_COOKIE}=${code}; path=/; max-age=${ONE_YEAR_SECONDS}; samesite=lax`;
}
